import React, { useEffect, useState } from "react";
import { BusinessHoursModel, DaysInAWeek } from "../../models/channels/channels.model";
import { Checkbox, FormControlLabel } from "@mui/material";
import ArrowTimePickerComponent from "../shared/datetimepicker/arrow-timepicker.component"



interface IProps {
    BusinessHours: BusinessHoursModel;
    IsMobileDevice: boolean;
    handleBusinessHours: (BusinessHours: BusinessHoursModel) => void;
    DisableSelect: boolean;
}

const SelectBusinessHoursComponent: React.FC<IProps> = (props: IProps) => {

    const handleCheckBox = () => {
        const data = { ...props.BusinessHours, SELECTED: !props.BusinessHours.SELECTED }
        props.handleBusinessHours(data)
    }

    const handleOpenTime = (time) => {
        const data = { ...props.BusinessHours, OPEN_TIME: time }
        props.handleBusinessHours(data)
    }

    const handleCloseTime = (time) => {
        const data = { ...props.BusinessHours, CLOSE_TIME: time }
        props.handleBusinessHours(data)
    }

    return (
        <div className="w-p-100 h-p-12 d-flex align-center  flex-direction">
            <div className="w-p-100 h-p-50  d-flex align-center">
                <div className={`${props.IsMobileDevice ? "w-p-36" : "w-26"} h-p-100 d-flex align-center o-hidden`}>
                    <FormControlLabel classes={{ label: `${props.IsMobileDevice ? "h5-medium" : "h5-medium"} w-space color-primary-accent ` }} control={
                        <Checkbox
                            className=""
                            checked={props.BusinessHours.SELECTED}
                            value={props.BusinessHours.SELECTED}
                            onChange={handleCheckBox}
                            classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                        />}
                        label={props.BusinessHours.DAY}
                    />
                </div>
                <div className={` ${props.IsMobileDevice ? "w-p-30" : "w-15"} h-p-100`}>
                    <ArrowTimePickerComponent Value={props.BusinessHours.OPEN_TIME} handleChange={handleOpenTime} TextLabel={""} IsMobileDevice={props.IsMobileDevice} ClassName={"br-1"} IsDisabled={props.DisableSelect} />
                </div>
                <div className="w-p-4 h-p-100 d-flex justify-center align-center">
                    -
                </div>
                <div className={` ${props.IsMobileDevice ? "w-p-30" : "w-15"} h-p-100`}>
                    <ArrowTimePickerComponent Value={props.BusinessHours.CLOSE_TIME} handleChange={handleCloseTime} TextLabel={""} IsMobileDevice={props.IsMobileDevice} ClassName={"br-1"} IsDisabled={props.DisableSelect} />
                </div>
            </div>
        </div>
    )
}

export default SelectBusinessHoursComponent;